import {
  GOOGLE_ADS_SLOT_TYPE_OUT_OF_PAGE,
  GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
} from '@sgcmpteltd/uikit-next/components/google-ads';
import type { GoogleAdsConfig } from '@sgcmpteltd/uikit-next/types';

export const newCarListingLeaderboard: GoogleAdsConfig = {
  adUnitPath: '/1707400/M_NewCars_Listing_Leaderboard',
  divId: 'div-gpt-ad-1747726468367-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
    size: [600, 400],
  },
};

export const listingBanner1: GoogleAdsConfig = {
  adUnitPath: '/1707400/M_Newcar_Listing_Banner1',
  divId: 'div-gpt-ad-1640316325917-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
    size: [320, 100],
  },
  targetingMap: {
    pageType: 'new-cars',
  },
};

export const listingBanner2: GoogleAdsConfig = {
  adUnitPath: '/1707400/M_Newcar_Listing_Banner2',
  divId: 'div-gpt-ad-1640316754913-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
    size: [300, 250],
  },
  targetingMap: {
    pageType: 'new-cars',
  },
};

export const promoListingBanner1: GoogleAdsConfig = {
  adUnitPath: '/1707400/M_Newcar_PromoListing_Banner1',
  divId: 'div-gpt-ad-1612708287402-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
    size: [320, 100],
  },
  targetingMap: {
    pageType: 'new-cars',
  },
};

export const promoListingBanner2: GoogleAdsConfig = {
  adUnitPath: '/1707400/M_Newcar_PromoListing_Banner2',
  divId: 'div-gpt-ad-1668432857383-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
    size: [300, 250],
  },
  targetingMap: {
    pageType: 'new-cars',
  },
};

export const infoBanner: GoogleAdsConfig = {
  adUnitPath: '/1707400/M_Newcar_Info_TopBanner',
  divId: 'div-gpt-ad-1640316652344-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
    size: [[320, 50], [320, 100]],
  },
};

export const ptoPopup: GoogleAdsConfig = {
  adUnitPath: '/1707400/M_Home_PTO',
  divId: 'div-gpt-ad-1586582791843-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_OUT_OF_PAGE,
  },
};

export const mobileNewCarPromo: GoogleAdsConfig = {
  adUnitPath: '/1707400/M_TA_PopUp',
  divId: 'div-gpt-ad-1710405929797-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
    size: ['fluid'],
  },
};

export const mobileNewCarCompetitorPromo: GoogleAdsConfig = {
  adUnitPath: '/1707400/M_TA_Competitor_PopUp',
  divId: 'div-gpt-ad-1710405887614-0',
  slot: {
    type: GOOGLE_ADS_SLOT_TYPE_WITHIN_PAGE,
    size: ['fluid'],
  },
};
